import { useEffect } from "react";
import { NextPage } from "next";

import { IErrorPageProps } from "@Interfaces/pages/Error";
// import styles from "./404.module.scss";

const Custom404: NextPage<IErrorPageProps> = () => {
    useEffect(() => {
        window.location.href =
            `//${process.env.NEXT_PUBLIC_PROJECT_DOMAIN}` ||
            "https://exlyapp.com";
    }, []);
    return null;
    // Left this JSX commented since this will be revamped soon
    // return (
    //     <div className={styles.container}>
    //         <Head>
    //             <title>Not Found</title>
    //         </Head>
    //         <div className={styles.title}>{t("common:NotFound")}</div>
    //         <Link href="/">
    //             <div className={styles.button}>{t("common:BackHome")}</div>
    //         </Link>
    //     </div>
    // );
};

export default Custom404;
